import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Payload} from "../../../../core/service/payload/payload";
import {
    AbstractActionNoCacheService
} from "../../../../core/service/v2/service/action/abstractActionNoCache.service";

@Injectable()
export class FormComputeRulesService
    extends AbstractActionNoCacheService<FormComputeRulesPayload, FormComputeRulesResponse[]> {

    public constructor(
                       httpClient: HttpClient) {
        super('v1/forms', 'compute-rules', httpClient);
    }
}

export class FormComputeRulesPayload implements Payload {
    ruleDefinitionNames: string[] = [];
    fields: FormComputeRulesPayloadField[] = [];
}

export class FormComputeRulesPayloadField implements Payload {
    value: any;
    fieldDefinitionId: number;
}

export class FormComputeRulesResponse {
    fieldDefinitionName: string;
    value: any
}


